import { httpsCallable } from "firebase/functions";
import { functions } from "@/lib/firebase";
import type { GetGlobalUsageStatsResponse } from "@/redux/api/analytics.rtkq";

// Usage logging response types
export interface LogPdfExtractionUsageResponse {
  success: boolean;
  creditsDeducted: number;
  remainingCredits: number;
}

export interface LogAnalyzerUsageResponse {
  success: boolean;
  creditsDeducted: number;
  remainingCredits: number;
  newTotalBalance: number;
}

export const updateAccountSubscription = httpsCallable(functions, "manuallySetSubscription");
export const manuallyUpdateAccountCredits = httpsCallable(functions, "manuallyUpdateAccountCredits");
export const cancelSubscription = httpsCallable(functions, "cancelSubscription");
export const agentTuningProxy = httpsCallable(functions, "agentTuningProxy");
export const getAgentTuningStatus = httpsCallable(functions, "getAgentTuningStatus");

// Usage logging functions
export const logPdfExtractionUsage = httpsCallable<
  { docId: string; fileId?: string; pageCount?: number },
  LogPdfExtractionUsageResponse
>(functions, "logPdfExtractionUsage");

export const logAnalyzerUsage = httpsCallable<
  any, // TODO: Add proper request type based on AnalyzerUsageParams from backend
  LogAnalyzerUsageResponse
>(functions, "logAnalyzerUsage");

// AI Assistant Proxy with extended timeout (9 minutes to match server timeout)
// The RAG API can take significant time for complex queries
export const aiAssistantProxy = httpsCallable(functions, "aiAssistantProxy", {
  timeout: 540000, // 9 minutes (540 seconds) - matches server-side timeout
});

// Terms of Service functions
export const getLatestTermsOfService = httpsCallable(functions, "getLatestTermsOfService");
export const getTermsOfServiceByVersion = httpsCallable(functions, "getTermsOfServiceByVersion");
export const acceptTermsOfService = httpsCallable(functions, "acceptTermsOfService");
export const checkUserTosStatus = httpsCallable(functions, "checkUserTosStatus");
export const createUserAccountWithTos = httpsCallable(functions, "createUserAccountWithTos");
export const updateUserTosAcceptance = httpsCallable(functions, "updateUserTosAcceptance");

// Admin functions (super admin only)
export const upsertTermsOfService = httpsCallable(functions, "upsertTermsOfService");
export const getAllTermsOfServiceVersions = httpsCallable(functions, "getAllTermsOfServiceVersions");
export const getGlobalUsageStats = httpsCallable<{ days?: number }, GetGlobalUsageStatsResponse>(
    functions,
    "getGlobalUsageStats"
);

// Court Decisions & Net Law Scraper (super admin only)
export const getCourtScraperStats = httpsCallable<void, { success: boolean; data: any }>(
  functions,
  "getCourtScraperStats"
);
export const listCourtScraperDocuments = httpsCallable<any, { success: boolean; data: any }>(
  functions,
  "listCourtScraperDocuments"
);
export const getCourtDocumentMedia = httpsCallable<any, { success: boolean; data: any }>(
  functions,
  "getCourtDocumentMedia"
);
export const getCourtFilterOptions = httpsCallable<void, { success: boolean; data: any }>(
  functions,
  "getCourtFilterOptions"
);

